<template>
  <div class="rules">
    <v-card class="common-card lighten-4">
      <h4 class="shopDeeppurple--text fs-large">قوانین و مقررات</h4>

      <v-col xl="8" lg="8" md="12" sm="12" xs="12">
        <div class="items-rules">
          <div class="icon_number_rule">
            <h1>1</h1>
          </div>

          <h5 class="mainFont--text">
            کتاب‌های چاپی بدون عیب و نقص ظاهری، بسته بندی و برای مشتری ارسال
            خواهند شد.
          </h5>
        </div>
      </v-col>
      <v-col xl="8" lg="8" md="12" sm="12" xs="12">
        <div class="items-rules">
          <div class="icon_number_rule">
            <h1>2</h1>
          </div>

          <h5 class="mainFont--text">
            در هنگام خرید دقت بفرمایید که باید سال چاپ را مدنظر قرار دهید.
          </h5>
        </div>
      </v-col>
      <v-col xl="8" lg="8" md="12" sm="12" xs="12">
        <div class="items-rule">
          <div class="icon_number_rule"></div>

          <h5>به خاطر سال چاپ متفاوت مرجوعی نخواهیم داشت.</h5>
        </div>
      </v-col>
      <v-col xl="8" lg="8" md="12" sm="12" xs="12">
        <div class="items-rules">
          <div class="icon_number_rule">
            <h1>3</h1>
          </div>
          <h5 class="mainFont--text">
            سال چاپ، تعداد صفحات، نویسنده کتاب‌ها، همواره بروز هستند و می‌توانید
            در هنگام خرید آن‌ها را مد نظر قرار دهید.
          </h5>
        </div>
      </v-col>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Rules",
  metaInfo() {
    return {
      title: `قوانین و مقررات| کتاب باز`, // Meta title
      meta: [
        {
          name: "description",
          content: "قوانین و مقررات استفاده و خرید از فروشگاه آنلاین کتاب باز", // Meta description
        },
        {
          property: "og:title", // Open Graph meta tag
          content: "قوانین و مقررات",
        },
        {
          property: "og:description",
          content: "قوانین و مقررات استفاده و خرید از فروشگاه آنلاین کتاب باز",
        },
      ],
    };
  },
  beforeDestroy() {
    // Reset the meta title when leaving the page
    document.title = "کتاب باز"; // Replace with your default title
    // Optionally, remove any other meta tags
    const metaTags = document.querySelectorAll(
      "meta[data-vue-router-controlled]"
    );
    metaTags.forEach((tag) => tag.parentNode.removeChild(tag));
  },
};
</script>

<style lang="scss">
.rules {
  overflow: hidden;
  .common-card {
    position: relative;
    min-height: 300px;
    @media only screen and (max-width: 600px) {
      padding-bottom: 250px !important;
    }
    .image-box {
      position: absolute;
      left: 30px;
      width: 200px;
      height: 200px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      @media only screen and (max-width: 600px) {
        left: 10px;
      }
    }
  }
  a {
    color: black !important;
  }
}
.items-rules,
.items-rule {
  margin-top: 20px;
  display: flex;
  align-items: center;
  .icon_number_rule {
    h1 {
      color: #6200ea;
      font-size: 20px;
      font-weight: bolder;
      margin: 0 !important;
      margin-left: 10px !important;
    }
  }
  h5 {
    font-size: 15px;
    margin: 0 !important;
  }
}
.items-rule {
  .icon_number_rule {
    background: transparent;
  }
  h5 {
    color: #d62728;
  }
}
</style>
